
export default class PaymentController {
    constructor(resource) {
        this._resource = resource;
    }

    async report(beginDate,endDate) {
        let response = null
        try {
            let result = await this._resource(`transactions/report`).get({ datas: { beginDate, endDate } })
            return result
        } catch (error) {
            throw error
        }
    }

    capturePayment(payment) {
        let paymentValue = payment.amount.replace(",", "")
        while(paymentValue.includes(".")){
            paymentValue = paymentValue.replace(".", "")
        }
        return this._resource(`cielo-payment/${payment.creditCardId}`).save({ paymentValue })
            .then(res => {
                return res.body
            }, err => {
                throw err
            });
    }

    capturePreAuthorization(vehicleRequestId, value) {
        value = value.toString()
        value = value.replace(",", "")
        while(value.includes(".")){
            value = value.replace(".", "")
        }
        return this._resource(`cielo-pre-authorization/${vehicleRequestId}`).save({ value })
            .then(res => {
                return res.body
            }, err => {
                throw err
            });
    }

    async getTokenBraspag(){
        return await this._resource('getTokenBraspag')
            .save()
            .then( res => {
                return res.body    
            }, error => { throw error })
    }     
    
    async getCardBin(cardNumber){
        return await this._resource(`cardBin/${cardNumber}`)
            .get()
            .then( res => {
                return res.body    
            }, error => { throw error })
    } 
}